<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: yd
 * @LastEditTime: 2020-10-21 10:39:14
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showEdit="hasBtn('edit-on-behalf-application-configuration')"
                       :show_del="hasBtn('delete-on-behalf-application-configuratio')"
                       :showReturn='false'
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <BusinessApply :disabled='readonly'
                   @changeReadonly='handleEdit'></BusinessApply>
  </div>
</template>
 
<script>
// this.$emit('changeReadonly')
// @changeReadonly='handleEdit'
import { deleteBusinessApply } from '@/service/api/businessApply.js'
import BusinessApply from './BusinessApply'
export default {
  components: {
    BusinessApply
  },
  props: {},
  data () {
    return {
      readonly: false,
    };
  },
  computed: {},
  created () { },
  watch: {},
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteBusinessApply({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'businessApply',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
